import DnDUploader, {
  DisplayAsset,
  StaticAssetPreview,
} from '@1stLog-engineering/file-uploads'
import { Box, Stack } from '@mantine/core'
import { concat, isEmpty, size } from 'lodash'
import React, { ReactElement } from 'react'

import {
  FeedbackBadge,
  Label,
} from '../../../../../../1stlog-ui/src/components/Field'
import useFieldRaw from '../../../../../../1stlog-ui/src/components/Field/useFieldRaw'

type TradeInvoiceUploadProps = {
  isRequired?: boolean
}

export const TradeInvoiceUpload = (
  props: TradeInvoiceUploadProps,
): ReactElement => {
  const { isRequired } = props

  const {
    input: { value: invoiceDocument, onChange: setInvoiceDocument },
    meta,
  } = useFieldRaw<DisplayAsset[]>('invoiceDocument', {
    ignorePrefix: true,
    subscribeAll: true,
    validate: (v: DisplayAsset[]) => {
      if (isRequired && isEmpty(v)) {
        return i18n.t(
          'trade_invoice_is_required',
          'Handelsrechnung ist erforderlich',
        )
      }
    },
  })

  const onAssetsAdded = (assets: DisplayAsset[]): void => {
    setInvoiceDocument(concat(invoiceDocument, assets).filter(Boolean))
  }

  const onAssetDelete = (index: number): void => {
    const newAssets = invoiceDocument.filter((_, i) => i !== index)
    setInvoiceDocument(newAssets)
  }

  return (
    <>
      <Box>
        <Label required={isRequired}>
          {i18n.t('trade_invoice_label', 'Handelsrechnung')}
        </Label>
        <Stack>
          <Box>
            <DnDUploader
              acceptedMimeTypes={[
                'image/png',
                'image/jpeg',
                'image/jpeg',
                'image/gif',
                'application/pdf',
              ]}
              allowedFileSize={52428800 / 5}
              maxFiles={1}
              currentFileCount={size(invoiceDocument)}
              onAssetAdded={onAssetsAdded}
            />
          </Box>
          <Box>
            <StaticAssetPreview
              assets={invoiceDocument}
              maxWidth="100%"
              height="200px"
              onDelete={(index) => onAssetDelete(index)}
            />
            <FeedbackBadge meta={meta} />
          </Box>
        </Stack>
      </Box>
    </>
  )
}
